const sizes = {
  mobile: "768px",
  tablet: "1024px",
  desktop: "1440px",
};

export const media = {
  mobile: `(max-width: ${sizes.mobile})`,
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(max-width: ${sizes.desktop})`,
};
